import { Layout, ListTitle, MTools } from "@/components";
import {getMediaDetail, getNewsDetail, getImgNewsDetail } from "@/services/service";
import React, { Component } from "react";
import styles from "./index.less";
import BetterScroll from "@better-scroll/core";
import PullUp from "@better-scroll/pull-up";
import { createRef } from "react";

interface NewsDetailProps {}
interface NewsDetailState {
  current: number;
  list: any;
  size: number;
  total: number;
  loading: boolean;
  hasMore: boolean;
  tabIndex: number;
}
BetterScroll.use(PullUp);

class NewsDetail extends Component<NewsDetailProps, NewsDetailState> {
  indexRef: any;
  bs: any;
  constructor(props: NewsDetailProps) {
    super(props);
    this.state = {
      current: 1,
      list: {},
      size: 10,
      total: 0,
      loading: false,
      hasMore: true,

      tabIndex: 0,
    };
    this.indexRef = createRef();
  }

  componentDidMount() {
    this.getData();
    this.init();
  }

  init = () => {
    // this.bs = new BetterScroll(this.indexRef.current, {
    //   pullUpLoad: true,
    //   click: true,
    //   bounce: false,
    // });
    // this.bs.on("pullingUp", () => {
    //   this.getData();
    //   this.bs.finishPullUp();
    // });
  };

  getData = async () => {
    if (!this.state.hasMore) return;
    this.setState({
      loading: true,
    });
    const local = window.location.pathname.split("/");
    const localType = window.location.search.split("?type=");
    const Id = local.length ? local[local.length - 1] : null;
    const Type = localType.length ? localType[localType.length - 1] : null;

    if (Type == 'news') {
      this.getNewsDetail(Id);
    } else if (Type == 'media') {
      this.getMediaDetail(Id);
    } else if (Type === 'imgNews') {
      this.getImgNewDetail(Id);
    }

    this.setState({
      loading: false,
    });
  };

  onTabs = (i: number) => {
    this.setState({
      tabIndex: i,
    });
  };

  // 获取图片新闻详情
  getImgNewDetail = async (_id: string | null) => {
    const result = await getImgNewsDetail(_id)
    if (result.success) {
      result.data.content = result.data.edit;
      this.setState({
        list: result.data
      })
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }
  }


  //获取各地新闻详情
  getNewsDetail = async (Id: any) => {
    const result = await getNewsDetail(Id)
    if (result.success) {
      this.setState({
        list: result.data
      })
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }
  }

  // 获取主题日新闻详情
  getMediaDetail = async (Id: any) => {
    const result = await getMediaDetail(Id)
    if (result.success) {
      result.data.content = result.data.edit;
      console.log(result.data,22222)
      this.setState({
        list: result.data
      })
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }
  }



  render() {
    const local = window.location.pathname.split("/");
    const Id = local.length ? local[local.length - 1] : null;
    const { list } = this.state;
    return (
      <div className={styles.index} ref={this.indexRef}>
        <Layout padding={23} share={true} businessType={1} businessId={Id}>
          <div className={styles.wrapper}>
            <div className={styles.title}>{list.name || list.title}</div>
            <div
              className={styles.innerHtml}
              dangerouslySetInnerHTML={{
                __html: list.content,
              }}
            ></div>
          </div>
        </Layout>
      </div>
    );
  }
}

export default NewsDetail;
